import React from 'react';
import cx from 'classnames';

import { ReactComponent as Arrow } from 'app/components/svg/Arrow.svg';

import s from './Arrow.module.sass';

type ArrowProps = {
  className?: string
  theme?: keyof typeof sortClass
};

const sortClass = {
  ascending: s.up,
  descending: s.down,
};

const ArrowSvg: React.FC<ArrowProps> = ({
  className,
  theme = 'descending',
}) => {
  const compoundClassName = cx(
    s.root,
    sortClass[theme],
    className,
  );

  return (
    <div className={compoundClassName}>
      <Arrow />
    </div>
  );
};

export default ArrowSvg;
